<template>
  <div class="companies">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[
            { text: $t('meta.containers'), name: 'company_containers' },
            { text: container.name, name: 'company_container', params: { container_uuid: container.uuid } },
            { text: $t('containers.emptyDate') },
          ]"
        />
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <EmptyingTemplateShowForm
          v-if="Object.keys(emptyTemplate).length > 0"
          :currentEmptyTemplate="emptyTemplate"
          :afterSubmit="onSubmit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import EmptyingTemplateShowForm from '@/components/EmptyingTemplates/ShowForm.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import containersApi from '@/api/container'
import emptyTemplatesApi from '@/api/emptyTemplates'

export default {
  name: 'company_container_type',
  data() {
    return {
      container: {},
      emptyTemplate: {},
    }
  },
  components: {
    BreadCrumbs,
    CompanyNav,
    EmptyingTemplateShowForm,
    SectionHeader,
  },
  methods: {
    async getData() {
      this.container = await containersApi.get(this.$route.params.container_uuid)
      this.emptyTemplate = await emptyTemplatesApi.get(
        this.$route.params.container_uuid,
        this.$route.params.template_uuid,
      )
    },
    async onSubmit(templateNewData) {
      const result = await emptyTemplatesApi.update(
        this.$route.params.container_uuid,
        this.$route.params.template_uuid,
        templateNewData,
      )
      if (result.success) {
        await this.getData()
      }
    },
  },
  async mounted() {
    await this.getData()
  },
}
</script>
